import React from "react";
import { Modal } from "react-bootstrap";

interface Props {
	texto: string;
	setTexto: (t: string) => void;
	titulo: string;
	setTitulo: (t: string) => void;
	busy: boolean;
	error: string | null;
	onGuardar: () => void;
	onClose: () => void;
}

/**
 * "+ Nota" del CRM (Esteban, 2026-10-03: abría un cuadro que no se podía cerrar). Ventana que se cierra con la X,
 * con Cancelar, con Esc y tocando fuera, en computadora y en celular. El borrador se queda en la ficha: si se cierra
 * sin guardar, al volver a abrir sigue ahí.
 */
const NotaModal: React.FC<Props> = ({ texto, setTexto, titulo, setTitulo, busy, error, onGuardar, onClose }) => (
	<Modal show onHide={onClose} className="ventas-nuevo-modal crm-nota-modal" aria-labelledby="crm-nota-titulo">
		<Modal.Header closeButton closeLabel="Cerrar">
			<Modal.Title id="crm-nota-titulo" style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Nota</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			{/* Título opcional (Esteban, 2026-10-16, Nancy): se ve en negritas arriba de la nota. */}
			<input className="crm-nota-titulo" value={titulo} onChange={(e) => setTitulo(e.target.value)} maxLength={120}
				placeholder="Título (opcional)" aria-label="Título de la nota" />
			<textarea autoFocus rows={5} placeholder="Escribe la nota de esta persona…" value={texto} aria-label="Nota"
				onChange={(e) => setTexto(e.target.value)}
				onKeyDown={(e) => { if (e.key === "Enter" && (e.metaKey || e.ctrlKey) && texto.trim() && !busy) onGuardar(); }} />
			{error ? <div className="crm-aviso error" style={{ marginTop: 10, marginBottom: 0 }}>{error}</div> : null}
		</Modal.Body>
		<Modal.Footer>
			<button className="crm-b" onClick={onClose}>Cancelar</button>
			<button className="crm-b azul" disabled={busy || !texto.trim()} onClick={onGuardar}>{busy ? "Guardando…" : "Guardar nota"}</button>
		</Modal.Footer>
	</Modal>
);

export default NotaModal;
